export default __webpack_public_path__ + "static/media/5.540dcef5.jpeg";